export const DRAFT_ORDER_COMPLETED = 'COMPLETED'
export const DRAFT_ORDER_OPEN = 'OPEN'